import { render, staticRenderFns } from "./ReviewChangeProposalsModal.vue?vue&type=template&id=5b904d34&scoped=true&"
import script from "./ReviewChangeProposalsModal.vue?vue&type=script&lang=js&"
export * from "./ReviewChangeProposalsModal.vue?vue&type=script&lang=js&"
import style0 from "./ReviewChangeProposalsModal.vue?vue&type=style&index=0&id=5b904d34&prod&lang=scss&"
import style1 from "./ReviewChangeProposalsModal.vue?vue&type=style&index=1&id=5b904d34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b904d34",
  null
  
)

export default component.exports